<main class="main app-main" >
  <router-outlet></router-outlet>
  <!-- <button (click)="test()">Test</button>
  <button (click)="logout()">Logout</button> -->
  <app-toaster></app-toaster>
</main>
<app-loading-overlay />
<app-toaster />
<app-credit-check-dialog/>

@if (updateService.isDownloading()) {
  <div class="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-slate-950/95 text-white p-6 select-none backdrop-blur-md">
    <div class="max-w-md w-full text-center space-y-8 p-8 bg-slate-900/80 border border-slate-800 rounded-3xl shadow-2xl">
      <!-- Icon/Spinner -->
      <div class="flex justify-center">
        <div class="relative flex items-center justify-center">
          <!-- Outer pulsing ring -->
          <div class="absolute w-20 h-20 rounded-full border-4 border-orange-500/20 animate-ping"></div>
          <!-- Inner spinning loader -->
          <div class="w-16 h-16 rounded-full border-4 border-t-orange-500 border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>
          <!-- Center brand mark or update icon -->
          <div class="absolute text-orange-500">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Update Text -->
      <div class="space-y-3">
        <h2 class="text-3xl font-black tracking-tight bg-gradient-to-r from-orange-400 to-amber-500 bg-clip-text text-transparent">Updating NorthAI</h2>
        <p class="text-slate-300 text-sm leading-relaxed">
          A new version of NorthAI is downloading in the background. 
          To prevent application errors, we've paused navigation.
        </p>
      </div>

      <!-- Progress / Status Indicator -->
      <div class="bg-slate-950/40 rounded-2xl p-5 border border-slate-800/80">
        <div class="flex items-center justify-between text-xs text-slate-400 mb-2">
          <span>Download progress</span>
          <span class="font-bold text-orange-500 animate-pulse">Downloading...</span>
        </div>
        <div class="w-full bg-slate-800 h-2 rounded-full overflow-hidden">
          <div class="bg-gradient-to-r from-orange-500 to-amber-500 h-full rounded-full animate-pulse" style="width: 100%"></div>
        </div>
        <p class="text-[11px] text-slate-500 mt-3 font-medium">Please do not close or reload this tab.</p>
      </div>
    </div>
  </div>
}
